import React, { useEffect } from 'react';
// Styles
import './styles/style.css';
import './styles/mac-os-ui.css';
import './styles/findings.css';

// UI Components
import MacMenuBar from './components/ui/MacMenuBar';
import MacClassicWindow from './components/ui/MacClassicWindow';
import InteractiveLogo from './components/ui/InteractiveLogo';

// Content Sections
import AuditsSection from './components/sections/AuditsSection';
import TopFindingsSection from './components/sections/TopFindingsSection';
import BugBountySection from './components/sections/BugBountySection';
import ContestSection from './components/sections/ContestSection';
import ContributionSection from './components/sections/ContributionSection';
import ContactSection from './components/sections/ContactSection';

// Utils
import { getCurrentYear } from './utils/dateUtils';

function App() {
  const currentYear = getCurrentYear();

  // Animate sections on scroll into view
  useEffect(() => {
    const sections = document.querySelectorAll('section');
    sections.forEach(s => s.classList.add('section-hidden'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-reveal');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    sections.forEach(s => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <MacMenuBar />

      <div className="container" style={{ marginTop: '30px', marginBottom: '30px' }}>
        <MacClassicWindow title="Merlinboii Classic">
          <div style={{ padding: '10px' }}>
            <header>
              <div className="container">
                <div className="hero">
                  <InteractiveLogo />
                  <p>portfolio dot exe</p>
                </div>
              </div>
            </header>
            
            <TopFindingsSection />
            <AuditsSection />
            <BugBountySection />
            <ContestSection />
            <ContributionSection />
            <ContactSection />
            
            <footer>
              <div className="container">
                <div className="footer-logo"> 
                  <img
                    src="images/merlinboii-pixel.png"
                    alt="merlinboii"
                    loading="lazy"
                  />
                </div>
                <p>&copy; {currentYear} merlinboii. All rights reserved.</p>
              </div>
            </footer>
          </div>
        </MacClassicWindow>
      </div>
    </div>
  );
}

export default App;